import { createFileRoute } from "@tanstack/react-router";

import { AskMara } from "~/components/feature/ask-mara";

export const Route = createFileRoute("/_app/ask/mara")({
  component: RouteComponent,
});

function RouteComponent() {
  return <AskMara />;
}
